import React from "react";
import FormikInput from "../../Formik/FormikInput";
import { useLanguage } from "../../LangTranslation/LanguageContext";

const Notes = ({ name, value, onChange, ...restProps }) => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  return (
    <div
      className="container"
      style={{ maxWidth: "1100px", height: "100%", padding: "10px" }}
    >
      <FormikInput
        {...restProps}
        textArea
        name={name}
        value={value}
        placeholder={t["Description"]}

      />
    </div>
  );
};

export default Notes;
